<template>
  <div id="app">
    <div>
      <el-image class="image" src="http://www.lf12333.net/img/1.jpg">
      </el-image>
      <div class="ban">
        <div class="ban_text">
          廊坊市职称合格人员情况查询 ————
          数据由廊坊市人力资源和社会保障局专业技术人员管理科提供
          联系电话：6266766
        </div>
      </div>

      <div class="desc desc_text">
        查询步骤：1、输入姓名、身份证号、证书编号 2、按“开始查询”。
      </div>

      <div>
        <!-- <div class="search_option">
          <select class="select_option" v-model="selectedOption">
            <option value="none">选择检索项目</option>
            <option value="name">姓名</option>
            <option value="exam">准考证号</option>
          </select>
        </div> -->
        <div class="search_input">
          <div class="t">姓名:</div>
          <input
            class="search_input_class"
            type="text"
            name="name"
            placeholder="请输入姓名"
            v-model="searchValue"
            @click="searchValue = ''"
          />
        </div>
        <div class="search_input">
          <div class="t">身份证号:</div>
          <input
            class="search_input_class"
            type="text"
            placeholder="请输入身份证号"
            name="name"
            v-model="branch"
            @click="branch = ''"
          />
        </div>
        <div class="search_input">
          <div class="t">证书编号:</div>
          <input
            class="search_input_class"
            placeholder="请输入证书编号"
            type="text"
            name="name"
            v-model="series"
            @click="series = ''"
          />
          <div class="search_button" @click="search">开始查询</div>
        </div>
      </div>

      <div class="table_class">
        <table class="tablecontent" v-if="isshow">
          <tbody>
            <tr>
              <th>姓名</th>
              <th>身份证号</th>
              <th>性别</th>
              <th>单位</th>
              <th>从事专业</th>
              <th>证书编号</th>
              <th>是否通过</th>
              <th>申报等级</th>
            </tr>
            <tr>
              <td>{{ data.name }}</td>
              <td>{{ data.branch }}</td>
              <td>{{ data.age }}</td>
              <td>{{ data.unit }}</td>
              <td>{{ data.major }}</td>
              <td>{{ data.series }}</td>
              <td>{{ data.pass }}</td>
              <td>{{ data.class }}</td>
            </tr>
          </tbody>
        </table>

        <table class="tablecontent" v-if="iserrshow">
          <tbody>
            <tr>
              <th>姓名</th>
              <th>身份证号</th>
              <th>性别</th>
              <th>单位</th>
              <th>从事专业</th>
              <th>证书编号</th>
              <th>是否通过</th>
              <th>申报等级</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isshow: false,
      iserrshow: false,
      branch: "",
      series: "",
      data: null,
      searchValue: "",
      selectedOption: "none",
    };
  },
  mounted() {
    document.title = "廊坊市社会职称公共查询";
  },
  methods: {
    async search() {
      if (this.searchValue == "") {
        alert("姓名不能为空!");
        return;
      }
      if (this.branch == "") {
        alert("身份证不能为空!");
        return;
      }
      if (this.series == "") {
        alert("证书编号不能为空!");
        return;
      }
      try {
        const response = await axios.get("https://www.lf12333.net/api", {
          params: {
            name: this.searchValue,
            branch: this.branch,
            series: this.series,
          },
        });
        if (response.data.code == 0) {
          alert("未查询到相关数据!");
          this.iserrshow = true;
        } else {
          this.data = response.data.data;
          this.isshow = true;
        }
      } catch (error) {
        alert("未查询到相关数据!");
      }
    },
  },
};
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #2c3e50;
}
.image {
  width: 960px;
  height: 120px;
}

body {
  margin: 0;
  padding: 0;
}
.ban {
  background-color: #a0a0a0;
  height: 30px;
  width: 100%;
  color: #ffffff;
  text-align: left;
}

.ban_text {
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.desc {
  height: 20px;
  width: 100%;
  margin-top: 10px;
}

.desc_text {
  font-size: 14px;
  color: red;
}

.search_button {
  margin-left: 100px;
  float: left;
  width: 80px;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c2c2c2;
  color: #000000;
  cursor: pointer;
}
.search_input_class {
  width: 380px;
}

.search_input {
  margin-top: 10px;
  margin-left: 20px;
  display: flex;
  width: 680px;
  height: 20px;
  line-height: 20px;
  font-size: 17px;
}
.t {
  min-width: 90px;
  text-align: left;
  font-size: 14px;
}
.t::before {
  content: "*";
  color: red;
  margin-left: 3px;
  font-size: 14px;
}
.select_option {
  width: 330px;
}
.search_option {
  width: 350px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  float: left;
}

.search {
  height: 20px;
  font-size: 12px;
  width: 100%;
  margin-top: 20px;
}

/* 基础样式 */
.tablecontent {
  width: 100%;
  border-collapse: collapse;
}
.tablecontent th:nth-child(2),
.tablecontent td:nth-child(2) {
  /* 身份证号列 */
  width: 15%;
}

.tablecontent th:nth-child(4),
.tablecontent td:nth-child(4) {
  /* 单位列 */
  width: 20%;
}
td,
th {
  border: 1px solid #c2c2c2;
  font-size: 12px;
  text-align: left;
  color: #000000;
}

th {
  background-color: #c2c2c2;
  color: white;
  text-align: center;
  font-size: 12px;
}

.table_class {
  border: 1px solid #c2c2c2;
  width: 100%;
  font-size: 12px;
  margin-top: 10px;
  margin-left: 10px;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .image {
    width: 380px;
    height: 50px;
  }
  .ban {
    background-color: #a0a0a0;
    width: 380px;
    height: 10px;
    color: #ffffff;
    text-align: left;
    margin-left: 0;
  }

  .ban_text {
    height: 10px;
    line-height: 10px;
    font-size: 6px;
  }

  .desc {
    height: 10px;
    width: 100%;
    margin-top: 3px;
  }

  .desc_text {
    font-size: 6px;
    color: red;
    height: 10px;
  }

  .search_button {
    margin-left: 20px;
    margin-top: 1px;
    float: left;
    width: 40px;
    height: 10px;
    font-size: 6px;
    line-height: 10px;
    text-align: center;
    background-color: #c2c2c2;
    color: #000000;
  }
  .search_input_class {
    width: 160px;
    font-size: 6px;
  }
  .t::before {
    font-size: 6px;
    margin-left: 3px;
  }
  .search_input {
    margin-top: 2px;
    margin-left: 3px;
    display: flex;
    width: 300px;
    height: 12px;
    line-height: 12px;
    font-size: 5px;
  }
  .t {
    min-width: 50px;
    text-align: left;
    font-size: 5px;
  }

  .select_option {
    font-size: 6px;
    width: 130px;
  }
  .search_option {
    width: 150px;
    height: 10px;
    font-size: 12px;
    line-height: 10px;
    float: left;
  }

  .search {
    height: 10px;
    font-size: 6px;
    width: 100%;
    margin-top: 8px;
  }

  td,
  th {
    border: 1px solid #c2c2c2;
    font-size: 5px;
    text-align: left;
    color: #000000;
  }

  th {
    background-color: #c2c2c2;
    color: white;
    text-align: center;
    font-size: 5px;
  }

  .table_class {
    border: 1px solid #c2c2c2;
    width: 380px;
    font-size: 5px;
    margin-top: 10px;
    margin-left: 0;
  }
  option {
    font-size: 12px;
  }
}
</style>
